import React from 'react'
import bannerend from '../../assets/images/shape8.png'
import LetterPad from '../LetterPad'
import Forms from '../Forms'
import { Col, Row } from 'antd'
import { MailFilled, PhoneFilled } from '@ant-design/icons'

const ContactUs = () => {
  return (
<>
<div className='contactUs-banner'>
        <div className='contactUsBanner'>
          {/* <img src={bannerend} alt='' className='bottomImg' style={{ rotate: "180deg" }} /> */}
          <h1>Contact Us</h1>
        </div>
      </div>
      <div className='aboutUs-section4' style={{display:"block"}}>

      <Row>
<Col xs={24} sm={24} md={24} lg={12} xl={12}>
<div className='contact-details '>
    <h5><span><PhoneFilled /></span>&nbsp;&nbsp; +91 9600881327 | +91 9600881328</h5>
    <h5><span><MailFilled /></span>&nbsp;&nbsp; tours@travelanceholidays.com</h5>
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.738035935167!2d80.2497308!3d13.0523396!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267cd679acacf%3A0x4228f55bb6122e2d!2sTravelance%20holidays%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1735580729971!5m2!1sen!2sin" title='Our Address' width="600" height="450" style={{border:0 , width : "100%"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>
</Col>
<Col xs={24} sm={24} md={24} lg={12} xl={12} style={{padding : 20}}>
<div className="form-travel">
<Forms />
</div>
</Col>
</Row>
</div>
      <LetterPad />
</>
 )
}

export default ContactUs